const productInfoSelector = (state) => state.productInfo;

export default productInfoSelector;
